import ClaimListing, { ClaimColumns, ClaimFilters, ClaimStatus } from '../shared/ClaimListing/ClaimListing';

export default function RejectedTab() {
  return (
    <ClaimListing
      columns={[
        ClaimColumns.insuredName,
        ClaimColumns.reinsuranceYear,
        ClaimColumns.policyNumber,
        ClaimColumns.sce,
        ClaimColumns.state,
        ClaimColumns.effectiveDate,
        ClaimColumns.endDate,
        ClaimColumns.claimNumber,
      ]}
      filters={[ClaimFilters.insuredNameSearch, ClaimFilters.policyNumber, ClaimFilters.claimNumber]}
      additionalPayload={{ status: ClaimStatus.Attached }}
      includeExport={false}
    />
  );
}
